import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  // Tracking Temporary
  {
    path: '/trackingtemp/',
    name: 'Tracking Temporary',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['temporary_live_views:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/trackingtemp/'),
  },

  {
    path: '/trackingtemp/create',
    name: 'Tracking Temporary Add',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['temporary_live_views:create'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/trackingtemp/form'),
  },

  {
    path: '/trackingtemp/update/:id',
    name: 'Tracking Temporary Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['temporary_live_views:update'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/trackingtemp/form'),
  },

  {
    path: '/trackingtemp/liveview',
    name: 'Tracking Temporary Map',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['temporary_live_views:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/trackingtemp/liveview'),
  },

  {
    path: '/fleet/live-track/:id',
    name: 'Tracking Temporary Liveview',
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        next()
      },
    },
    component: () => import('@/router/views/trackingtemp/liveview'),
  },
]
